import React from 'react'
import { useIntl } from 'react-intl'
import { Box, Container, Typography } from '@mui/material';

import { withStyles } from '@mui/styles'

import { JCAHistFilter, JCAHistTable } from '../../../../features/ip3-historical'
import { useCombos } from '../../../../features/combos'
import { IP3_HIST_COMBOS_IDS } from '../../constants'
import { jcaHistDashboardStyles } from './jca-hist-dashboard.styles'

export const JCAHistDashboardPage = withStyles(jcaHistDashboardStyles)(({ classes }) => {
  useCombos(IP3_HIST_COMBOS_IDS)
  const { formatMessage } = useIntl()

  return (
    <Container className={classes.container} maxWidth="xl">
      <Box mb={2}>
        <Typography variant="h4" color="textSecondary">
          {formatMessage({ id: 'pages.ip3Historical.jca.dashboard.title' })}
        </Typography>
      </Box>
      <Box mb={2} display="flex">
        <JCAHistFilter />
      </Box>
      <Box>
        <JCAHistTable />
      </Box>
    </Container>
  )
})
